var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-0 blue-background",attrs:{"fluid":""}},[_vm._v(" "+_vm._s(_vm.$t('Oops!'))+" "+_vm._s(_vm.$t("The content you're looking for does not exists."))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }